var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('basic-card',{attrs:{"title":_vm.title,"cardWidth":"6","description":_vm.description}},[_c('plotly',{attrs:{"data":_vm.chartData,"layout":_vm.layout,"id":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }